import { ChannelType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredString } from '@/utils/zodUtils';

export const CreateChannelSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      description: requiredString(t),
      type: requiredEnum(ChannelType, t),
    })
    .strict();

export type CreateChannelType = z.infer<ReturnType<typeof CreateChannelSchema>>;
